<template>
  <div class="wrap">
    <div class="banner">
      <div class="text animated fadeIn">
        <p class="icon"></p>
        <p class="h2">新闻中心</p>
      </div>
    </div>
    <div class="inner">
      <el-tabs tab-position="left">
        <el-tab-pane
          v-for="(tab, index) in newsCenterList"
          :key="index"
          :label="tab.label"
        >
          <component :is="tab.component"></component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TabJilinAccident from './TabJilinAccident.vue'
import TabMedicalDevice from './TabMedicalDevice.vue'
import TabLargeEquipment from './TabLargeEquipment.vue'
import TabOxygenConcentrator from './TabOxygenConcentrator.vue'
import TabPressConference from './TabPressConference.vue'
import TabHealthcareReform from './TabHealthcareReform.vue'
import TabMedicalReform from './TabMedicalReform.vue'
import TabHierarchicalMedical from './TabHierarchicalMedical.vue'
import TabInnovationPlan from './TabInnovationPlan.vue'
export default {
  name: 'newsCenter',
  props: {
    index: Number
  },
  data () {
    return {
      newsCenterList: [
        {
          label: '（摘录）吉林氧气事故',
          component: TabJilinAccident
        },
        {
          label: '2017年7月开始实行新《医疗器械标准管理办法》',
          component: TabMedicalDevice
        },
        {
          label: '卫计委要求：医疗机构一律停购大型医用设备',
          component: TabLargeEquipment
        },
        {
          label: '新规YY1468-2016《用于医用气体管道系统的氧气浓缩器供气系统》',
          component: TabOxygenConcentrator
        },
        {
          label: '十九大第五次记者会，民政部人社部卫计委回答要点记录（摘录）',
          component: TabPressConference
        },
        {
          label: '医保、药价改革： 将致医药行业增速放缓、毛利降低',
          component: TabHealthcareReform
        },
        {
          label: '十九大报告为医改领域描绘了新的蓝图',
          component: TabMedicalReform
        },
        {
          label: '广东分级诊疗模式初步形成',
          component: TabHierarchicalMedical
        },
        {
          label: '《“十三五”医疗器械科技创新专项规划》',
          component: TabInnovationPlan
        }
      ]
    }
  },
  mounted () {

  },
  watch: {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 444px;
  margin-top: 76px;
  background: url("../../assets/images/bedside-banner.png") no-repeat center;
  text-align: center;
  overflow: hidden;
  .text {
    display: inline-block;
    margin: 117px auto 0;
  }
  .icon {
    width: 105px;
    height: 105px;
    margin: 0 auto;
    background: url("../../assets/images/banner5-icon.png") no-repeat center;
    background-color: #ffffff;
    border-radius: 50%;
  }
  .h2 {
    font-size: 30px;
    color: #fff;
    margin-top: 62px;
  }
}
.inner {
  width: 1200px;
  min-height: 1000px;
  margin: 20px auto;
  background-color: #f2f2f2;
  padding: 10px;
  /deep/ .el-tabs {
    min-height: 1000px;
    display: flex;
    .el-tabs__header {
      .el-tabs__nav {
        .el-tabs__active-bar {
          height: 0px !important;
        }
        .el-tabs__item {
          width: 260px;
          height: 60px;
          background-color: #ffffff;
          margin-bottom: 10px;
          padding: 10px;
          line-height: 25px;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          text-align: left;
          cursor: pointer;
          overflow: hidden;
          white-space: normal;
          word-wrap: break-word;
        }
      }
    }
    .el-tabs__content {
      width: 100%;
      background-color: #ffffff;
      margin-left: 20px;
      padding: 10px;
    }
    .el-tabs__item {
      width: 100%;
    }
    .el-tab-pane {
      flex: 1;
    }
    .el-tabs__item.is-active {
      background-color: #0051b3 !important;
      color: white;
    }
  }
}
/deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after,
.el-tabs--left .el-tabs__nav-wrap.is-right::after,
.el-tabs--right .el-tabs__nav-wrap.is-left::after,
.el-tabs--right .el-tabs__nav-wrap.is-right::after {
  width: 0px !important;
}
</style>
